/**
 * HyperFormula 3 does not ship INDIRECT. Rewrite the one pattern we use in
 * DocHub templates so totals still calculate after expandable row inserts.
 *
 * Sheets: =SUM(INDIRECT("D11:D"&ROW()-1))
 * Meaning: sum from fixed start cell through the row above this formula.
 */

const INDIRECT_SUM_ROW_RELATIVE =
  /^=\s*SUM\s*\(\s*INDIRECT\s*\(\s*"([A-Z]+)(\d+):\1"\s*&\s*ROW\s*\(\s*\)\s*-\s*1\s*\)\s*\)$/i;

/**
 * @param {import('hyperformula').HyperFormula} hf
 * @param {number} sheetId
 */
export const rewriteUnsupportedIndirectFormulas = (hf, sheetId) => {
  if (!hf || sheetId == null) return;

  let rowCount = 0;
  let colCount = 0;
  try {
    const { width, height } = hf.getSheetDimensions(sheetId);
    colCount = width;
    rowCount = height;
  } catch (e) {
    return;
  }

  for (let row0 = 0; row0 < rowCount; row0++) {
    for (let col0 = 0; col0 < colCount; col0++) {
      let formula;
      try {
        formula = hf.getCellFormula({ sheet: sheetId, row: row0, col: col0 });
      } catch (e) {
        continue;
      }
      if (!formula) continue;

      const match = String(formula).match(INDIRECT_SUM_ROW_RELATIVE);
      if (!match) continue;

      const colLetter = match[1];
      const startRow1 = Number(match[2]);
      // ROW()-1 in 1-based coords equals this cell's 0-based row index.
      const endRow1 = row0;
      if (!colLetter || !Number.isFinite(startRow1) || startRow1 < 1 || endRow1 < startRow1) {
        continue;
      }

      const replacement = `=SUM(${colLetter}${startRow1}:${colLetter}${endRow1})`;
      try {
        hf.setCellContents({ sheet: sheetId, row: row0, col: col0 }, [[replacement]]);
      } catch (e) {
        // ignore
      }
    }
  }
};
